import React from 'react';
import Svg from '../Svg';

const IconFaceContent = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM10.6315 8.46462C11.0597 8.81338 11.1241 9.44326 10.7754 9.87149C10.2152 10.5593 9.40285 11 8.5 11C7.58714 11 6.7988 10.551 6.23632 9.88559C5.87977 9.46382 5.93264 8.83286 6.35441 8.47631C6.77618 8.11976 7.40714 8.17264 7.76368 8.59441C8.0212 8.89904 8.28286 9 8.5 9C8.72715 9 8.99477 8.89073 9.22462 8.6085C9.57339 8.18027 10.2033 8.11585 10.6315 8.46462ZM17.6315 8.46462C18.0597 8.81338 18.1241 9.44326 17.7754 9.87149C17.2152 10.5593 16.4028 11 15.5 11C14.5871 11 13.7988 10.551 13.2363 9.88559C12.8798 9.46382 12.9326 8.83286 13.3544 8.47631C13.7762 8.11976 14.4071 8.17264 14.7637 8.59441C15.0212 8.89904 15.2829 9 15.5 9C15.7272 9 15.9948 8.89073 16.2246 8.6085C16.5734 8.18027 17.2033 8.11585 17.6315 8.46462Z"
    />
  </Svg>
);

export default IconFaceContent;
